import { render, staticRenderFns } from "./SettingsEmailTemplateRichEditor.vue?vue&type=template&id=248a7cf8"
import script from "./SettingsEmailTemplateRichEditor.vue?vue&type=script&lang=ts"
export * from "./SettingsEmailTemplateRichEditor.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEmailTemplateRichEditor.vue?vue&type=style&index=0&id=248a7cf8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports